if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));

        if (this.elements.button) {
          this.elements.button.addEventListener('click', this.openSelector.bind(this));
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }

        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a[data-value]').forEach((item) =>
          item.addEventListener('click', this.onItemClick.bind(this))
        );
      }

      ensureHiddenInput(form, name, value) {
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
        return input;
      }

      getReturnPath(countryCode) {
        const englishPath = window.location.pathname.replace(/^\/fr(?=\/|$)/, '') || '/';
        const targetPath =
          countryCode === 'FR'
            ? englishPath === '/'
              ? '/fr/'
              : `/fr${englishPath}`
            : englishPath;

        return `${targetPath}${window.location.search || ''}${window.location.hash || ''}`;
      }

      hidePanel() {
        if (this.elements.button) this.elements.button.setAttribute('aria-expanded', 'false');
        if (this.elements.panel) this.elements.panel.setAttribute('hidden', true);

        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }

        document.body.classList.remove('overflow-hidden-mobile');
        const drawer = document.querySelector('.menu-drawer');
        if (drawer) drawer.classList.remove('country-selector-open');
        if (this.header) this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a[data-value]')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            if (itemToFocus) itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            if (itemToFocus) itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          this.elements.search.setAttribute(
            'aria-activedescendant',
            focusedItemIndex > -1 ? focusableItems[focusedItemIndex].id : ''
          );
        });
      }

      onContainerKeyUp(event) {
        if (!this.elements.button) return;
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') === 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') === 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();

        const form = this.querySelector('form');
        const selectedValue = event.currentTarget.dataset.value;
        if (!form || !selectedValue || !this.elements.input) return;

        this.elements.input.value = selectedValue;

        if (this.elements.input.name === 'country_code') {
          this.ensureHiddenInput(form, 'country_code', selectedValue);
          this.ensureHiddenInput(form, 'locale_code', selectedValue === 'FR' ? 'fr' : 'en');
          this.ensureHiddenInput(form, 'return_to', this.getReturnPath(selectedValue));

          try {
            sessionStorage.removeItem('turapura-localization-sync');
          } catch (error) {}
        }

        form.submit();
      }

      openSelector() {
        if (!this.elements.button || !this.elements.panel) return;

        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );

        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }

        if (this.elements.search && this.mql.matches) this.elements.search.focus();
        if (this.hasAttribute('data-prevent-hide') && this.header) this.header.preventHide = true;

        const drawer = document.querySelector('.menu-drawer');
        if (drawer) drawer.classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        if (!this.elements.search) return;

        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a[data-value]');
        let visibleCountries = 0;

        if (this.elements.resetButton) {
          this.elements.resetButton.classList.toggle('hidden', !searchValue);
        }

        if (popularCountries) popularCountries.classList.toggle('hidden', Boolean(searchValue));

        allCountries.forEach((item) => {
          const countryElement = item.querySelector('.country');
          if (!countryElement) return;

          const countryName = this.normalizeString(countryElement.textContent);
          const visible = countryName.indexOf(searchValue) > -1;
          item.parentElement.classList.toggle('hidden', !visible);
          if (visible) visibleCountries++;
        });

        if (this.elements.liveRegion && window.accessibilityStrings?.countrySelectorSearchCount) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        const selector = this.querySelector('.country-selector');
        const list = this.querySelector('.country-selector__list');
        if (selector) selector.scrollTop = 0;
        if (list) list.scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        if (!this.elements.search) return;
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        if (this.elements.searchIcon) this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (this.elements.searchIcon && !this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') event.preventDefault();
      }
    }
  );
}

(() => {
  const marketFromPath = /^\/bg(?:\/|$)/.test(window.location.pathname)
    ? { country: 'BG', locale: 'bg' }
    : /^\/fr(?:\/|$)/.test(window.location.pathname)
      ? { country: 'FR', locale: 'fr' }
      : null;
  if (!marketFromPath) return;

  const syncKey = 'turapura-localization-sync';
  const currentUrlKey = `${window.location.pathname}${window.location.search || ''}`;

  const getCountryCode = () => {
    if (window.Shopify && typeof window.Shopify.country === 'string' && window.Shopify.country) {
      return window.Shopify.country.toUpperCase();
    }

    const countryInput = document.querySelector('localization-form form input[name="country_code"]');
    return countryInput?.value?.toUpperCase() || '';
  };

  const synchronizeMarket = () => {
    if (getCountryCode() === marketFromPath.country) {
      try {
        sessionStorage.removeItem(syncKey);
      } catch (error) {}
      return;
    }

    try {
      if (sessionStorage.getItem(syncKey) === currentUrlKey) return;
    } catch (error) {}

    const countryForms = Array.from(document.querySelectorAll('localization-form form')).filter((form) =>
      form.querySelector('input[name="country_code"]')
    );

    const form =
      countryForms.find((candidate) => /HeaderCountry/i.test(candidate.id || '')) ||
      countryForms.find((candidate) => /FooterCountry/i.test(candidate.id || '')) ||
      countryForms[0];

    if (!form) return;

    const ensureInput = (name, value) => {
      let input = form.querySelector(`input[name="${name}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value;
    };

    ensureInput('country_code', marketFromPath.country);
    ensureInput('locale_code', marketFromPath.locale);
    ensureInput(
      'return_to',
      `${window.location.pathname}${window.location.search || ''}${window.location.hash || ''}`
    );

    try {
      sessionStorage.setItem(syncKey, currentUrlKey);
    } catch (error) {}

    form.submit();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', synchronizeMarket, { once: true });
  } else {
    synchronizeMarket();
  }
})();
